<template>
  <v-app
    style="background: #f2f3f8"
  >
    <app-bar />
    <base-view />
  </v-app>
</template>

<script>
  export default {
    components: {
      BaseView: () => import('./View'),
      AppBar: () => import('./AppBar'),
    },

    computed: {
    },
  }
</script>

<style lang="scss" scoped></style>
